<template>
    <section class="comp_settings_main">
        <div class="comp_scroller">
            <div class="comp_content">
                <header class="wrp_comp_header mod--row mod--row-flex mod--row-middle">
                    <div class="col">
                        <h1 class="part_ui_heading"><span>{{ $t('settings') }}</span></h1>
                    </div>
                </header>
                <div class="wrp_comp_body" v-on:scroll="handleGlobalScroll($event)">
                    <div class="mod--row mod--row-4">
                        <div class="col col--12">
                            <router-link to="/logout" class="elm_nav_item"><span>{{ $t('logout') }}</span></router-link>
                        </div>
                        <div class="col col--12">
                            <div class="elm_item mod--mt-16">
                                <div class="mod--row mod--row-flex mod--row-middle">
                                    <div class="col col--6">
                                        <label for="locale" class="elm_label"><span>{{ $t('language') }}</span></label>
                                    </div>
                                    <div class="col col--6 mod--right">
                                        <div class="part_ui_select">
                                            <select name="locale" id="locale" v-model="locale"
                                                    v-on:change="changeLocale">
                                                <option v-for="locale in locales" v-bind:value="locale.iso">
                                                    {{ locale.name }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col col--12">
                            <div class="elm_item">
                                <div class="mod--row mod--row-flex mod--row-middle">
                                    <div class="col col--6">
                                        <label for="channel" class="elm_label"><span>{{ $t('default_channel') }}</span></label>
                                    </div>
                                    <div class="col col--6 mod--right">
                                        <div class="part_ui_select">
                                            <select name="channel" id="channel" v-model="default_channel_id"
                                                    v-on:change="changeChannel">
                                                <option v-for="option in channels" :value="option.channel_id">
                                                    {{ option.channel_id }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col col--12">
                            <div class="elm_item">
                                <div class="mod--row mod--row-flex mod--row-middle">
                                    <div class="col col--6">
                                        <label for="showDecimals" class="elm_label"><span>{{
                                                $t('show_decimals')
                                            }}</span></label>
                                    </div>
                                    <div class="col col--6 mod--right">
                                        <label class="part_ui_switch">
                                            <input id="showDecimals" type="checkbox" v-model="show_decimals"
                                                   v-on:change="changeDecimals">
                                            <span></span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col col--12">
                            <div class="elm_item">
                                <div class="mod--row mod--row-flex mod--row-middle">
                                    <div class="col col--6">
                                        <label for="showTentative" class="elm_label"><span>{{
                                                $t('show_tentative')
                                            }}</span></label>
                                    </div>
                                    <div class="col col--6 mod--right">
                                        <label class="part_ui_switch">
                                            <input id="showTentative" type="checkbox" v-model="show_tentative"
                                                   v-on:change="changeTentative">
                                            <span></span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import axios from 'axios'
import moment from 'moment';

export default {
    name: 'settings-main',
    data() {
        return {
            locale: null,
            currency: null,
            default_channel_id: null,
            show_decimals: null,
            show_tentative: null,
            locales: [
                {
                    iso: 'cs',
                    name: 'Česky'
                },
                {
                    iso: 'en',
                    name: 'English',
                },
                {
                    iso: 'sk',
                    name: 'Slovenčina',
                }
            ],
            channels: []
        }
    },
    mounted() {
        this.currency = localStorage.getItem('currency');
        this.locale = localStorage.getItem('locale') || 'cs';
        this.default_channel_id = localStorage.getItem('default_channel_id');
        this.show_decimals = localStorage.getItem('show_decimals') === 'true';
        this.show_tentative = localStorage.getItem('show_tentative') === 'true';
    },
    methods: {
        setConfig: function (key, value) {
            localStorage.setItem(key, value);
        },
        changeLocale: function () {
            localStorage.setItem('locale', this.locale);
            this.$i18n.locale = this.locale;
            moment.locale(localStorage.getItem('locale') || 'cs')
        },
        changeChannel: function () {
            localStorage.setItem('default_channel_id', this.default_channel_id);
        },
        changeDecimals: function () {
            localStorage.setItem('show_decimals', this.show_decimals);
        },
        changeTentative: function () {
            localStorage.setItem('show_tentative', this.show_tentative);
        },
        getChannels: function () {
            this.loading = true;

            let data = `{
                        id
                        channel_id
                        active
                    }`;

            let query = `{listCMChannels ${data}}`;

            axios({
                data: query
            }).then(response => {
                this.channels = response.data.data.listCMChannels;
            }).catch(error => {
                this.showError(error)
            });
        },
    },
    created() {
        this.getChannels();
    }
}
</script>



// WEBPACK FOOTER //
// src/templates/comp/settings-main.vue